import React from 'react'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemText from '@material-ui/core/ListItemText'
import { t } from '../i18n'

/**
 * Menú contextual por miniatura de serie en Explorer.
 */
export default function ExplorerSeriesContextMenu({
  anchorEl,
  open,
  onClose,
  explorerIndex,
  isPinnedManual,
  isRefSeries,
  hideRetryDownload,
  isPreviewMode,
  onAction,
}) {
  const handle = (action) => (e) => {
    e.stopPropagation()
    if (onAction) {
      onAction(action, { explorerIndex })
    }
    if (onClose) onClose()
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      MenuListProps={{ dense: true }}
    >
      {isPinnedManual ? (
        <MenuItem onClick={handle('unpin')}>
          <ListItemText primary={t('explorer.menu.unpinDownload')} />
        </MenuItem>
      ) : (
        <MenuItem onClick={handle('pin')}>
          <ListItemText primary={t('explorer.menu.pinDownload')} />
        </MenuItem>
      )}
      {!hideRetryDownload ? (
        <MenuItem onClick={handle('retryDownload')}>
          <ListItemText primary={t('explorer.menu.retryDownload')} />
        </MenuItem>
      ) : null}
      <MenuItem onClick={handle('regenerateThumbnail')}>
        <ListItemText primary={t('explorer.menu.regenerateThumbnail')} />
      </MenuItem>
      <MenuItem onClick={handle('downloadSeries')}>
        <ListItemText
          primary={
            isPreviewMode
              ? t('explorer.menu.downloadSeriesPreview')
              : t('explorer.menu.downloadSeriesDicom')
          }
        />
      </MenuItem>
      <MenuItem onClick={handle('copySeriesUid')}>
        <ListItemText
          primary={t('explorer.menu.copySeriesUid')}
          secondary={isRefSeries ? t('explorer.menu.refSeriesHint') : undefined}
        />
      </MenuItem>
    </Menu>
  )
}
